import React from 'react';
import ResetPasswordForm from 'containers/ResetPasswordForm';
import SiteFlashes from 'containers/SiteFlashes';
import Card from 'components/general/Card/Card';

const ResetPassword = () => (
  <div className="island">
    <div className="island__box">
      <Card>
        <Card.Section>
          <SiteFlashes />
          <h1>Reset your password</h1>
          <p>Enter your new password.</p>
          <ResetPasswordForm />
        </Card.Section>
      </Card>
    </div>
  </div>
);

export default ResetPassword;
